import { formatNumber } from '@weft/utils';
import { formatNumberWithPrecision } from '../../../../utils/number';

type UsageTotalProgressProps = {
  total: number;
  max: number;
};

export const UsageTotalProgress: React.FC<UsageTotalProgressProps> = ({
  total,
  max,
}) => {
  const { percentage, percentageText } = calculateAndFormatPercentage(total, max);

  return (
    <div>
      <div className="flex items-center gap-1">
        <div className="text-xl font-medium text-black">
          {formatNumber(total)} 
        </div>
        {max > 0 && <div className="text-placeholder">{`/ ${formatNumber(max)}`}</div>}

        <div className='text-placeholder'>
          {percentageText}
        </div>
      </div>
      <div className="bg-gray relative z-10 mt-2 h-1 w-full max-w-[134px] rounded-lg">
        <div
          style={{ width: `${percentage > 100 ? 100 : percentage}%` }}
          className="absolute z-20 h-1 rounded-lg bg-[#C250FF] shadow-[#C250FF4D] drop-shadow-xl"
        />
      </div>
    </div>
  );
};

export function calculateAndFormatPercentage(total: number, max: number) {
  const percentage = max === 0 ? 0 : (total / max) * 100;
  const formattedPercentage = percentage === 0 ? 0 : formatNumberWithPrecision(percentage, 0);

  const percentageText = percentage > 100 ? `(+${formattedPercentage}%)` : `(%${formattedPercentage})`;
  
  return { percentage, percentageText };
}